/* ─────────────────────────────────────────────────────────
   Product Tabs – PDP block
   Vanilla JS, scoped per [data-product-tabs] instance.
   Keyboard: ← → to navigate, Enter/Space to activate.
   ───────────────────────────────────────────────────────── */

(function () {
  'use strict';

  function initTabs(container) {
    var tabs = Array.prototype.slice.call(
      container.querySelectorAll('[role="tab"]')
    );
    var panels = Array.prototype.slice.call(
      container.querySelectorAll('[role="tabpanel"]')
    );

    if (tabs.length < 2) return;

    function activateTab(tab) {
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
        t.classList.remove('product-tabs__tab--active');
      });

      panels.forEach(function (p) {
        p.hidden = true;
        p.classList.remove('product-tabs__panel--active');
      });

      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      tab.classList.add('product-tabs__tab--active');

      var panelId = tab.getAttribute('aria-controls');
      var panel = container.querySelector('#' + panelId);
      if (panel) {
        panel.hidden = false;
        panel.classList.add('product-tabs__panel--active');
      }

      /* Scroll active tab into view on mobile */
      if (tab.scrollIntoView) {
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function (e) {
        var index = tabs.indexOf(tab);
        var newIndex;

        if (e.key === 'ArrowRight' || e.key === 'Right') {
          newIndex = (index + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'Left') {
          newIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
          newIndex = 0;
        } else if (e.key === 'End') {
          newIndex = tabs.length - 1;
        } else {
          return;
        }

        e.preventDefault();
        activateTab(tabs[newIndex]);
        tabs[newIndex].focus();
      });
    });
  }

  function initAll() {
    var containers = document.querySelectorAll('[data-product-tabs]');
    for (var i = 0; i < containers.length; i++) {
      initTabs(containers[i]);
    }
  }

  /* Run on DOMContentLoaded or immediately if already loaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when Shopify theme editor adds/updates blocks */
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  }
})();
